<template>
  <div class="image-loader">
    <span class="skeleton-loader" v-if="isLoading"></span>
    <img v-bind="$attrs" v-else :src="src" @click="onClick">
  </div>
</template>

<script lang="ts">
import { useImage } from '@vueuse/core';
import { toRefs, defineComponent } from 'vue-demi';

export default defineComponent({
  name: 'ImageLoader',
  inheritAttrs: false,
  props: {
    src: {
      type: String,
      required: true,
    },
  },
  emits: ['click'],
  setup(props, { emit }) {
    const { src } = toRefs(props);
    const { isLoading } = useImage({ src: src.value });
    const onClick = () => emit('click');
    return {
      isLoading,
      onClick,
    };
  },
});
</script>

<style lang="less" scoped>
@rem: 200rem;

.image-loader {
  overflow: hidden;
  &>img {
    width: 100%;
    height: 100%;
  }
  .skeleton-loader {
    display: block;
    height: 100%;
    width: 100%;
    background: rgb(243, 243, 243);
    background: linear-gradient(to right, rgb(243, 243, 243) 8%,
        #ecebeb 33%, rgb(243, 243, 243) 66%);
    background-size: 750 / @rem 750 / @rem;
    animation: wave-squares 2s infinite linear;
  }
  @keyframes wave-squares {
    0% {
      background-position: -750 / @rem 0;
    }

    100% {
      background-position: 750 / @rem 0;
    }
  }

}
</style>
